var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5D6DB"
    },
    points: "133.44,287.587 128.226,335.865 126.809,349.318 114.257,465.893 0,436.926 15.385,376.225   15.449,376.225 19.311,360.776 19.375,360.776 43.128,267.118 51.754,268.92 ",
    "data-original": "#D5D6DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E1E6E9"
    },
    points: "234.143,267.108 234.143,436.885 114.241,465.865 133.426,287.634 ",
    "data-original": "#E1E6E9",
    className: ""
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5D6DB"
    },
    points: "234.143,267.108 234.143,436.885 354.045,465.865 334.86,287.634 ",
    "data-original": "#D5D6DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E1E6E9"
    },
    points: "468.293,436.926 354.036,465.893 341.483,349.318 340.067,335.865 334.854,287.587   416.024,269.049 425.165,267.118 448.982,360.776 452.909,376.225 ",
    "data-original": "#E1E6E9",
    className: ""
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#64798A"
    },
    points: "452.909,376.225 361.503,342.495 341.483,349.318 234.114,385.881 126.809,349.318   106.79,342.495 15.449,376.225 19.311,360.776 19.375,360.776 106.79,328.527 128.226,335.865 234.114,371.976 340.067,335.865   361.503,328.527 448.982,360.776 ",
    "data-original": "#64798A",
    className: ""
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M353.134,121.391c0,65.717-118.991,257.54-118.991,257.54s-118.991-191.824-118.991-257.54  S168.426,2.4,234.143,2.4S353.134,55.674,353.134,121.391z",
    "data-original": "#3A556A",
    className: "active-path",
    "data-old_color": "#302C30"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1E6E9"
    },
    cx: 234.14,
    cy: 121.275,
    r: 75.301,
    "data-original": "#E1E6E9",
    className: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4130527f91facd1d469abbb97e16e82a.svg";
export { ForwardRef as ReactComponent };